import { apiClientWithRefreshToken } from "@/api/apiClient";
import { CreateSupplierSchema } from "@/v2/schema/supplier";
import { Supplier } from "@/v2/types";

export default async function CreateSupplier(
    data: CreateSupplierSchema,
): Promise<Supplier> {
    const res = await apiClientWithRefreshToken({
        url: "/suppliers",
        method: "POST",
        data: data,
    });

    return res.data;
}
